import { useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Form, FormControl, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { BsFileEarmarkPdfFill, BsFillPencilFill, BsSearch } from 'react-icons/bs'
import {FaCircleCheck, FaCircleXmark, FaFileExcel} from 'react-icons/fa6'
import '../../../css/masterDetail.css'
import '../../../css/generalStyles.css'
import DSHeineken from '../Services/Heineken.Services'
import DataTable from 'react-data-table-component'
import { MsgInformativo } from '../../Utils/Toast/msgInformativo'
import xlsx from 'json-as-xlsx'
import DTORptFacturas from '../DTO/DTORptFacturas'
import { IconContext } from 'react-icons'
import FileManagerServices from '../../../Services/Utils/FileManager.Services'
import InputMask from 'react-input-mask'

export interface IFtpFacturasProps {}

export const RptFacturasT = (props: IFtpFacturasProps) => {
  const [UserId, setUserId] = useState(() => {
    const stickyValue = window.localStorage.getItem('UserId')
    return stickyValue !== null ? JSON.parse(stickyValue) : 0
  })
  const [Data, setData] = useState<DTORptFacturas[]>([])
  const [DataOriginal, setDataOriginal] = useState<DTORptFacturas[]>([])
  const [Inicio, setInicio] = useState(currentDate(-30))
  const [Fin, setFin] = useState(currentDate(0))
  const [filtro, setFiltro] = useState('')
  const [show, setShowMsg] = useState(false)
  const [header, setHeader] = useState('')
  const [msg, setMsg] = useState('')
  const [msgColor, setMsgColor] = useState('primary')
  //
  const [ModalFolioCartaPorte, setModalFolioCartaPorte] = useState(false)
  const [ModalFechas, setModalFechas] = useState(false)
  const [ID, setID] = useState(0)
  const [FolioCartaPorte, setFolioCartaPorte] = useState('')
  const [SCAC, setSCAC] = useState('')
  const [CAAT, setCAAT] = useState('')
  const [TransporteAmericano, setTransporteAmericano] = useState(false)
  const [FechaEstimadaCruce, setFechaEstimadaCruce] = useState('')
  const [FechaCita, setFechaCita] = useState('')
  const colData = [
    {
      name: 'id',
      width: '80px',
      selector: (row: DTORptFacturas) => row.id,
      sortable: true,
    },
    {
      name: 'Prefile',
      center: true,
      width: '80px',
      cell: (row: DTORptFacturas) => (
        <OverlayTrigger
          placement='top'
          overlay={ row.fechaPrefile ? <Tooltip id="button-tooltip-2">{row.fechaPrefile}</Tooltip> : <br style={{display:'none'}}/>}
        >
        <div style={
          row.fechaPrefile === '' ? {
            pointerEvents:'none',
            opacity: 0.5
          } : {
            
          }
        }>
          <IconContext.Provider value={{ color: 'red', size: '17px' }}>
            <BsFileEarmarkPdfFill 
              onClick={() => {
                GetPrefile(row.factura, row.factura2)
              }}
              style={{ cursor: 'pointer' }}
            />
          </IconContext.Provider>
        </div>
        </OverlayTrigger>
      ),
    },
    {
      name: 'Doda',
      center: true,
      width: '80px',
      cell: (row: DTORptFacturas) => (
        <OverlayTrigger
          placement='top'
          overlay={ row.fechaDoda ? <Tooltip id="button-tooltip-2">{row.fechaDoda}</Tooltip> : <br style={{display:'none'}}/>}
        >
          <div 
            style={
              row.fechaDoda === '' ? {
                pointerEvents:'none',
                opacity: 0.5
              } : {
                
              }
            }
          >
            <IconContext.Provider value={{ color: 'red', size: '17px' }}>
              <BsFileEarmarkPdfFill 
              onClick={() => {
                GetDoda(row.id)
              }}
              style={{ cursor: 'pointer' }}/>
            </IconContext.Provider>
          </div>
        </OverlayTrigger>
      ),
    },
    {
      name: 'BL',
      center: true,
      width: '60px',
      cell: (row: DTORptFacturas) => (
        <div
          onClick={() => {
            ShowBL2PDF(row.id)
          }}
          style={{ cursor: 'pointer' }}
        >
          <IconContext.Provider value={{ color: 'red', size: '17px' }}>
            <BsFileEarmarkPdfFill />
          </IconContext.Provider>
        </div>
      ),
    },
    {
      name: 'Folio Carta Porte',
      width: '320px',
      cell: (row: DTORptFacturas) => (
        <div
          style={{
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            setID(row.id)
            setFolioCartaPorte(row.folioCartaPorte)
            setSCAC(row.scac)
            setCAAT(row.caat)
            setTransporteAmericano(row.transporteAmericano)
            setModalFolioCartaPorte(true)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '13px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>{' '}
          &nbsp; {row.folioCartaPorte}
        </div>
      ),
    },
    {
      name: 'SCAC',
      width: '100px',
      selector: (row: DTORptFacturas) => row.scac,
      sortable: true,
    },
    {
      name: 'CAAT',
      width: '100px',
      selector: (row: DTORptFacturas) => row.caat,
      sortable: true,
    },
    {
      name: 'Transportista Americano',
      width: '200px',
      cell: (row: DTORptFacturas) => (
        <div
          style={{
            alignItems:'center',
            textAlign: 'center',
            cursor: 'pointer',
            width:'100%'
          }}
        >
          <IconContext.Provider value={{ color: row.transporteAmericano ? 'green' : 'red', size: '18px' }}>
            {row.transporteAmericano ? <FaCircleCheck/> : <FaCircleXmark/>}
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Trafico',
      width: '100px',
      selector: (row: DTORptFacturas) => row.trafico,
      sortable: true,
    },
    {
      name: 'Caja',
      width: '100px',
      selector: (row: DTORptFacturas) => row.caja,
      sortable: true,
    },
    {
      name: 'Pedido SAP',
      selector: (row: DTORptFacturas) => row.pedidoSAP,
      sortable: true,
    },
    {
      name: 'Fecha Estimada Cruce',
      width:'200px',
      cell: (row: DTORptFacturas) => (
        <div
          style={{
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            setID(row.id)
            setFechaEstimadaCruce(row.fechaEstimadaCruce)
            setFechaCita(row.fechaCita)
            setModalFechas(true)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '13px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>{' '}
          &nbsp; {row.fechaEstimadaCruce}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Fecha Cita',
      width:'150px',
      selector: (row: DTORptFacturas) => row.fechaCita,
      sortable: true,
    },
    {
      name: 'Proveedor',
      width: '200px',
      selector: (row: DTORptFacturas) => row.proveedor,
      sortable: true,
    },
    {
      name: 'Factura',
      selector: (row: DTORptFacturas) => row.factura,
      sortable: true,
    },
    {
      name: 'Factura 2',
      selector: (row: DTORptFacturas) => row.factura2,
      sortable: true,
    },
    {
      name: 'Pedido',
      selector: (row: DTORptFacturas) => row.pedido,
      sortable: true,
    },
    {
      name: 'Delivery',
      selector: (row: DTORptFacturas) => row.delivery,
      sortable: true,
    },
    {
      name: 'Shipment',
      selector: (row: DTORptFacturas) => row.shipment,
      sortable: true,
    },
    {
      name: 'Destino',
      selector: (row: DTORptFacturas) => row.destino,
      sortable: true,
    },
    {
      name: 'Fecha',
      selector: (row: DTORptFacturas) => row.fechaFactura,
      sortable: true,
    },
    {
      name: 'Aduana',
      selector: (row: DTORptFacturas) => row.aduana,
      sortable: true,
    },
    {
      name: 'Patente',
      selector: (row: DTORptFacturas) => row.patente,
      sortable: true,
    },
    {
      name: 'Pedimento',
      selector: (row: DTORptFacturas) => row.pedimento,
      sortable: true,
    },
    {
      name: 'Bultos',
      selector: (row: DTORptFacturas) => row.bultos,
      sortable: true,
    },
  ]

  function currentDate(days: number): string {
    var today = new Date()
    today.setDate(today.getDate() + days)
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    return yyyy + '-' + mm + '-' + dd
  }

  const loadReport = (Inicio: string, Fin: string) => {
    DSHeineken.GetFacturas(Inicio, Fin)
      .then((response) => {
        console.log(response.data)
        setData(response.data)
        setDataOriginal(response.data)
      })
      .catch((e: Error) => {
        alert('Ocurrio un error' + e.message.toString())
      })
  }

  const ShowBL2PDF = (id: number) => {
    FileManagerServices.getBL(id)
          .then((response: any) => {
            if (response.status === 200) {
              const blob = new Blob([response.data], { type: 'application/pdf' })
              const url = window.URL.createObjectURL(blob)
              window.open(url)
            }
          })
          .catch((e: Error) => {
            setHeader('Error')
            setMsg('Ocurrió un error al generar el BL')
            setShowMsg(true)
            return
          })
    /* const newWindow = window.open(
      process.env.REACT_APP_SERVICES +
        'heineken/services/BOL2PDF' +
        '?id=' +
        id,
      '_blank',
      'noopener,noreferrer'
    )
    if (newWindow) newWindow.opener = null */
  }

  const GetPrefile = (Factura: string, Factura2: string) => {
    FileManagerServices.getPrefile(Factura, Factura2.substring(2))
      .then((response: any) => {
        if (response.status === 200) {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          window.open(url)
        }
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Prefile no existe')
        setShowMsg(true)
        return
      })
  }

  useEffect(() => {
    loadReport(Inicio, Fin)
  }, [])

  const filtraReporte = (e: any) => {
    setFiltro(e.target.value)
    if (e.target.value.length > 0) {
      setData(
        DataOriginal.filter(function (row) {
          return (
            row.fechaFactura
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.factura
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.proveedor
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.destino
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.pedidoSAP
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.caja
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.transportista
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.aduana
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.patente
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) ||
            row.pedimento
              .toLowerCase()
              .includes(e.target.value.toLocaleLowerCase()) 
          )
        })
      )
    } else {
      setData(DataOriginal)
    }
  }

  function exportExcel(jsonData: DTORptFacturas[], fileName: string): void {
    let Heading = [
      [
        'Proveedor',
        'Factura',
        'Pedido',
        'Pedido SAP',
        'Delivery',
        'Shipment',
        'Destino',
        'Fecha de factura',
        'Aduana',
        'Patente',
        'Pedimento',
        'Caja',
        'Bultos',
      ],
    ]
    const dataOnly = jsonData.map(
      ({
        proveedor,
        factura,
        pedido,
        pedidoSAP,
        delivery,
        shipment,
        destino,
        fechaFactura,
        aduana,
        patente,
        pedimento,
        caja,
        bultos,
      }) => {
        return {
          proveedor,
          factura,
          pedido,
          pedidoSAP,
          delivery,
          shipment,
          destino,
          fechaFactura: { fechaFactura },
          aduana,
          patente,
          pedimento,
          caja,
          bultos,
        }
      }
    )
    let data = [
      {
        sheet: 'Facturas',
        columns: [
          { label: 'Proveedor', value: 'proveedor' },
          { label: 'Factura', value: 'factura' },
          { label: 'Pedido', value: 'pedido' },
          { label: 'Pedido SAP', value: 'pedidoSAP' },
          { label: 'Delivery', value: 'delivery' },
          { label: 'Shipment', value: 'shipment' },
          { label: 'Destino', value: 'destino' },
          {
            label: 'Fecha',
            value: (row: any) =>
              row.fechaFactura.fechaFactura
                ? row.fechaFactura.fechaFactura.substring(0, 10)
                : '',
          },
          { label: 'Aduana', value: 'aduana' },
          { label: 'Patente', value: 'patente' },
          { label: 'Pedimento', value: 'fechaEnvio' },
          { label: 'Caja', value: 'caja' },
          { label: 'Bultos', value: 'bultos' },
        ],
        content: dataOnly,
      },
    ]
    let settings = {
      fileName,
      extraLength: 3,
      writeOptions: {},
      RTL: false,
    }
    xlsx(data, settings)
  }

  const downloadExcel = () => {
    exportExcel(Data, 'Reporte de Facturas')
  }

  const GetDoda = (id: number) => {
    FileManagerServices.getFileContent(id, 34)
    .then((response: any) => {
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      }
    })
    .catch((e: Error) => {
      setHeader('Error')
      setMsg('Doda no existe')
      setShowMsg(true)
      return
    })
  }

  const saveFolioCartaPorte = () => {
    DSHeineken.AppendFolioCartaPorte(ID, FolioCartaPorte, SCAC, CAAT, TransporteAmericano)
      .then((response) => {
        setModalFolioCartaPorte(false)
        loadReport(Inicio, Fin)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error')
      })
  }

  const saveFechas = (id: number, FechaEstimadaCruce: string, FechaCita: string) => {
    DSHeineken.UpdateFechasCompromiso(id, FechaEstimadaCruce, FechaCita)
    .then(resp => {
      setModalFechas(false)
      loadReport(Inicio, Fin)
    })
    .catch(() => {
      setHeader('Error')
      setMsg('Ocurrió un error, favor de intentarlo nuevamente')
      setShowMsg(true)
      return
    })
  }

  return (
    <div style={{ padding: '10px' }}>
      <Card>
        <Card.Body>
          <Row className='mb-2'>
            <Col xs={2}>
              <Card.Title>Facturas</Card.Title>
            </Col>
            <Col xs={1}>
            </Col>
            <Col xs={1} style={{ textAlign: 'right' }}>
              Inicio
            </Col>
            <Col xs={1}>
              <Form.Control
                defaultValue={Inicio}
                type='date'
                name='Inicio'
                placeholder='Inicio'
                title='Inicio'
                alt='Inicio'
                data-date-format='YYYY-mm-dd'
                onChange={(e) => setInicio(e.target.value)}
                size='sm'
              />
            </Col>
            <Col xs={1} style={{ textAlign: 'right' }}>
              Hasta
            </Col>
            <Col xs={1}>
              <Form.Control
                defaultValue={Fin}
                type='date'
                name='Inicio'
                placeholder='Inicio'
                title='Inicio'
                alt='Inicio'
                data-date-format='YYYY-mm-dd'
                onChange={(e) => setFin(e.target.value)}
                size='sm'
              />
            </Col>
            
            <Col xs={4}>
              <Form.Control
                type='text'
                size='sm'
                placeholder='Search...'
                onChange={(e) => {
                  filtraReporte(e)
                }}
              />
            </Col>
            <Col xs={1}>
              <Button
                variant='primary'
                onClick={() => {
                  loadReport(Inicio, Fin)
                }}
              >
                <BsSearch />
                &nbsp;Buscar
              </Button>
            </Col>
          </Row>
          <Row className='justify-content-end'>
            <Col xs={4} style={{textAlign:'right'}}>
              <Button variant='success' onClick={() => {downloadExcel()}} style={{marginRight:'10px'}}> <FaFileExcel/>&nbsp;Excel</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Row style={{ paddingTop: '10px' }}>
        <Col xs={12}>
          <DataTable
            noHeader
            defaultSortFieldId={'id'}
            defaultSortAsc={true}
            pagination
            paginationPerPage={15}
            striped={true}
            dense={true}
            highlightOnHover
            columns={colData}
            data={Data.filter(function (row) {
              return row
            })}
          />
        </Col>
      </Row>
      <Modal
        show={ModalFolioCartaPorte}
        onHide={() => setModalFolioCartaPorte(false)}
        size='lg'
      >
        <Modal.Body>
          <Row className='justify-content-center align-items-end'>
            <Col xs={2}>
              <Form.Label>
                ¿Transportista Americano?
                <Form.Check
                  defaultChecked={TransporteAmericano}
                  onChange={() => {setTransporteAmericano(!TransporteAmericano)}}
                />
              </Form.Label>
            </Col>
            <Col xs={5}>
              <Form.Label style={{width:'100%'}}>
                Folio Carta Porte:
                <FormControl
                  type='text'
                  as={InputMask}
                  mask='********-****-****-****-************'
                  value={FolioCartaPorte}
                  alwaysShowMask={true}
                  disabled={TransporteAmericano}
                  onChange={(e) => {
                    setFolioCartaPorte(e.target.value)
                  }}
                />
              </Form.Label>
            </Col>
            <Col xs={2} >
                <Form.Label>
                  SCAC
                  <Form.Control 
                    type='input'
                    value={SCAC}
                    placeholder='SCAC'
                    onChange={(e) => {setSCAC(e.target.value)}}
                  />
                </Form.Label>
            </Col>
            <Col xs={2} >
                <Form.Label>
                  CAAT
                  <Form.Control 
                    type='input'
                    value={CAAT}
                    placeholder='CAAT'
                    onChange={(e) => {setCAAT(e.target.value)}}
                  />
                </Form.Label>
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs={11} style={{ textAlign: 'end' }}>
              <Button
                variant='secondary'
                onClick={() => setModalFolioCartaPorte(false)}
                size='sm'
              >
                Cerrar
              </Button>
              &nbsp;
              <Button
                variant='primary'
                onClick={() => saveFolioCartaPorte()}
                size='sm'
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        show={ModalFechas}
        onHide={() => {setModalFechas(false)}}
        centered
      >
        <Modal.Body>
          <Row>
            <Col xs={6}>
              <Form.Label style={{width:'100%'}}>
                Fecha Estimada de Cruce
                <Form.Control
                  defaultValue={FechaEstimadaCruce ? new Date(FechaEstimadaCruce).toISOString().split('T')[0] : ''}
                  type='date'
                  name='FechaEstimadaCruce'
                  placeholder='FechaEstimadaCruce'
                  title='FechaEstimadaCruce'
                  alt='FechaEstimadaCruce'
                  data-date-format='dd-mm-YYYY'
                  onChange={(e) => setFechaEstimadaCruce(e.target.value)}
                  size='sm'
                />
              </Form.Label>
            </Col>
            <Col xs={6}>
              <Form.Label style={{width:'100%'}}>
                Fecha Cita
                <Form.Control
                  defaultValue={FechaCita ? new Date(FechaCita).toISOString().split('T')[0] : ''}
                  type='date'
                  name='FechaCita'
                  placeholder='FechaCita'
                  title='FechaCita'
                  alt='FechaCita'
                  data-date-format='YYYY-mm-dd'
                  onChange={(e) => setFechaCita(e.target.value)}
                  size='sm'
                />
              </Form.Label>
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs={11} style={{ textAlign: 'end' }}>
              <Button
                variant='secondary'
                onClick={() => setModalFechas(false)}
                size='sm'
              >
                Cerrar
              </Button>
              &nbsp;
              <Button
                variant='primary'
                onClick={() => saveFechas(ID, FechaEstimadaCruce, FechaCita)}
                size='sm'
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        time={2000}
        msgColor={msgColor}
        closeToast={() => {
          setShowMsg(false)
        }}
      />
    </div>
  )
}
